var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPause = function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.04 3H3.95a.818.818 0 0 0-.819.818v16.364A.818.818 0 0 0 3.95 21h4.09a.818.818 0 0 0 .819-.818V3.818A.818.818 0 0 0 8.04 3ZM20.314 3h-4.091a.818.818 0 0 0-.819.818v16.364a.818.818 0 0 0 .819.818h4.09a.819.819 0 0 0 .819-.818V3.818A.818.818 0 0 0 20.313 3Z",
    fill: "currentColor"
  })));
};
export default SvgPause;